// A session's recap (qa-runs 1164): asked for once the DM's End the session is accepted. The table's server drafts it
// from the record into that day's session page in the campaign's wiki, through the site's backend; this page learns
// only what to say and the page's address on the site, to open in a new tab.
import { requestJson } from './api';

export interface RecapAnswer { text: string; url: string | null }

export async function draftRecap(campaignId: string, fetchImpl: typeof fetch = fetch): Promise<RecapAnswer> {
  const { status, body } = await requestJson(`/api/tables/${campaignId}/recap`, {
    method: 'POST', body: JSON.stringify({ offset: new Date().getTimezoneOffset() }),
  }, fetchImpl);
  const b = (body ?? {}) as { text?: unknown; url?: unknown; reason?: unknown };
  if (status === 201 && typeof b.text === 'string') return { text: b.text, url: typeof b.url === 'string' && /^https?:\/\//.test(b.url) ? b.url : null };
  if (typeof b.reason === 'string') return { text: b.reason, url: null };
  return { text: "The session's recap couldn't be drafted just now.", url: null };
}
